export enum AppTabs {
  Workspaces = 'workspaces',
  Shares = 'shares',
}
